<h1 mat-dialog-title>{{data.filename}}</h1>
<div mat-dialog-content style="padding-top: 20px;padding-bottom: 20px;">
	<a class="button" #download download="{{data.filename}}" (click)="closeDialog()">
		<mat-icon>save</mat-icon>
		&nbsp;
		{{'t_save' | translate}}
	</a>
</div>